export class ParametrosUACModel {
    public modulo: string;
    public tipoParametro: string;
    public idParametro: string;
    public descripcion: string;
    public valor: string;
    public letra: string;
    public estado: string;
    public fechaCreacion: Date;
    public fechaModificacion: Date;
    public modificadoPor: string;
    public nombre: string;
    public sede: string;
    public diasTramite:number;
    public sedesTramites: any[];
}